import { Fragment, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import Column from "@components/column";
import Row from "@components/row";
import Loader from "@components/loader";
import Typography from "@components/typography";
import OverviewCard from "@commons/cards/overview";
import { Dashboard as DashboardApi } from "@apis/index";

type PerformerType = "product" | "deliveryman" | "customer";

const TITLES: Record<PerformerType, string> = {
  product: "Top Selling Items",
  deliveryman: "Top Deliveryman",
  customer: "Top Customer",
};

const TopPerformers = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const type = (searchParams.get("type") as PerformerType) || "product";
  const moduleId = searchParams.get("moduleId");
  const zoneId = searchParams.get("zoneId");

  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await DashboardApi.topPerformers({
          state: "topPerformers",
          params: {
            limit: 50,
            ...(moduleId ? { moduleId } : {}),
            ...(zoneId ? { zoneId } : {}),
          },
        });
        setData(res);
      } catch (error) {
        console.error("Failed to fetch top performers", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [moduleId, zoneId]);

  const listByType: Record<PerformerType, any[]> = {
    product: data?.topSellingItems || [],
    deliveryman: data?.topDeliverymen || [],
    customer: data?.topCustomers || [],
  };

  const items = listByType[type] || [];

  return (
    <Fragment>
      <Column gap={16}>
        <Row styleRow="align-items:center;gap:10px;cursor:pointer">
          <div
            onClick={() => navigate(-1)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: "pointer",
            }}
          >
            <ArrowLeft size={20} />
            <Typography size={16} weight={500}>
              Back
            </Typography>
          </div>
        </Row>

        {loading ? (
          <Loader />
        ) : (
          <div style={{ maxWidth: "560px", width: "100%" }}>
            <OverviewCard title={TITLES[type]} data={items} type={type} showViewAll={false} />
          </div>
        )}
      </Column>
    </Fragment>
  );
};

export default TopPerformers;
